import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from './base.service';
import { ConstantsService } from './constants.service';
import { MetadataProp } from '../models/metadata-prop-model';

@Injectable({
  providedIn: 'root'
})
export class MetadataService extends BaseService {

  private dataSubject = new BehaviorSubject<MetadataProp[]>([]);
  public mdData$ = this.dataSubject.asObservable();

  mdItems: MetadataProp[] = [];

  constructor(public override http: HttpClient,
    public override constants: ConstantsService) {
    super(http, constants, constants.api_metadata);
  }

  setData(data: MetadataProp[]){
    this.dataSubject.next(data);
    this.mdItems = data;
  }

  getData(): MetadataProp[] {
    return this.dataSubject.value;
  }

  public getMetadata(): Observable<any> {
    return this.getAll();
  }

  public getSearchable(): MetadataProp[]
  {
    return this.mdItems.filter(item => item.searchable);
  }

  public getViewable(): MetadataProp[]
  {
    return this.mdItems.filter(item => item.viewable);
  }
  public getReportable(): MetadataProp[]
  {
    return this.mdItems.filter(item => item.reportable);
  }
}